import React from 'react';
import { useTranslation } from 'react-i18next';
import { Gamepad2, Grid3X3, Infinity } from 'lucide-react';

const WhyChoose = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: Gamepad2,
      title: t('whyChoose.games.title'),
      description: t('whyChoose.games.description'),
      color: 'red'
    },
    {
      icon: Grid3X3,
      title: t('whyChoose.genres.title'),
      description: t('whyChoose.genres.description'),
      color: 'purple'
    },
    {
      icon: Infinity,
      title: t('whyChoose.unlimited.title'),
      description: t('whyChoose.unlimited.description'),
      color: 'blue'
    }
  ];

  const colorClasses = {
    red: 'from-red-500/20 to-red-500/5 border-red-500/30 group-hover:border-red-500/60',
    purple: 'from-purple-500/20 to-purple-500/5 border-purple-500/30 group-hover:border-purple-500/60',
    blue: 'from-blue-500/20 to-blue-500/5 border-blue-500/30 group-hover:border-blue-500/60'
  };

  const iconColorClasses = {
    red: 'text-red-500',
    purple: 'text-purple-500',
    blue: 'text-blue-500'
  };

  return (
    <section id="games" className="py-20 md:py-32 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="font-display text-3xl md:text-5xl font-bold mb-4">
            <span className="gaming-gradient-text">{t('whyChoose.title')}</span>
          </h2>
        </div>

        {/* Feature cards */}
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className={`group p-8 rounded-2xl bg-gradient-to-b ${colorClasses[feature.color]} border transition-all duration-300 hover:transform hover:-translate-y-2`}
            >
              <div className={`w-16 h-16 rounded-xl bg-white/5 flex items-center justify-center mb-6 ${iconColorClasses[feature.color]}`}>
                <feature.icon className="w-8 h-8" />
              </div>
              <h3 className="text-xl font-bold mb-3">{feature.title}</h3>
              <p className="text-white/60 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
